import React from 'react'

const SiteLocation = (props) => {
  return (
    <h1 className="site-title">Native Plants of {props.state_}</h1>
  )
}

export default SiteLocation
